
'use client';

import { useEffect } from 'react';
import { useUser } from '@/firebase/client-provider';
import { useRouter } from 'next/navigation';

// Root page checks auth and redirects accordingly
// This is kept minimal to reduce initial bundle size
export default function HomePage() {
  const { user, loading: userLoading } = useUser();
  const router = useRouter();

  useEffect(() => {
    if (!userLoading) {
      // Use replace to avoid adding to history stack
      router.replace(user ? '/projects' : '/login');
    }
  }, [user, userLoading, router]);

  // Show minimal loading indicator while redirecting
  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="flex flex-col items-center gap-4">
        <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-muted-foreground">Loading...</p>
      </div>
    </div>
  );
}
